import React from "react";
import { Sparkles, MessageCircle, Clock, CheckCircle2 } from "lucide-react";
import { WHATSAPP_URL, trustItems } from "../data/mock";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#0d1a2c] text-[#ebe6d6]">
      <div className="absolute inset-0 hero-grid opacity-50" />
      <div className="absolute inset-0 hero-radial" />

      <div className="relative mx-auto grid max-w-[1280px] gap-12 px-5 py-20 md:px-10 md:py-28 lg:grid-cols-[1.1fr_1fr] lg:gap-16">
        {/* Left: copy */}
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#b89c60]/40 bg-[#b89c60]/5 px-4 py-1.5">
            <Sparkles className="h-3.5 w-3.5 text-[#b89c60]" strokeWidth={2.4} />
            <span className="text-[12px] font-semibold tracking-widest-custom text-[#b89c60]">
              TEMA 1.113 — STJ
            </span>
          </div>

          <h1 className="font-serif-display mt-8 text-[50px] leading-[1.05] text-[#ebe6d6] md:text-[68px]">
            Recupere o excesso pago no{" "}
            <span className="text-[#b89c60]">ITBI</span>{" "}
            sobre seu imóvel em São Paulo.
          </h1>

          <p className="mt-6 max-w-[560px] text-[15px] leading-relaxed text-[#a9b4c2] md:text-[16px]">
            A base de cálculo do ITBI deve ser o valor real da compra e não o valor venal
            da prefeitura. O STJ já decidiu: você tem direito à restituição do que foi pago
            a maior.
          </p>

          <div className="mt-10">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2.5 rounded-md bg-[#16a34a] px-7 py-4 text-[15px] font-medium text-white shadow-lg shadow-[#16a34a]/20 transition hover:bg-[#15803d]"
            >
              <MessageCircle className="h-5 w-5" strokeWidth={2.6} />
              Falar com Dr. Thiago no WhatsApp
            </a>
          </div>

          <ul className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
            {trustItems.map((t) => (
              <li key={t} className="flex items-center gap-2 text-[13px] text-[#8a96a4]">
                <CheckCircle2 className="h-4 w-4 text-[#b89c60]" strokeWidth={2.4} />
                {t}
              </li>
            ))}
          </ul>
        </div>

        {/* Right: stat card */}
        <div className="animate-fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative rounded-2xl border border-[#1a2a40] bg-gradient-to-b from-[#11243c] to-[#0d1a2c] p-8 elev-card-dark md:p-10">
            <div className="flex justify-center">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#b89c60]/30 bg-[#b89c60]/10">
                <Clock className="h-5 w-5 text-[#b89c60]" strokeWidth={2.4} />
              </div>
            </div>

            <div className="mt-8 text-center">
              <div className="font-serif-display text-[120px] leading-none text-[#b89c60] md:text-[140px]">
                5
              </div>
              <h3 className="font-serif-display mt-4 text-[22px] text-[#ebe6d6] md:text-[24px]">
                Comprou imóvel nos últimos 5 anos?
              </h3>
              <p className="mx-auto mt-3 max-w-[340px] text-[13px] leading-relaxed text-[#8a96a4]">
                O prazo para buscar a restituição do ITBI pago a maior é de até 5 anos a
                contar do pagamento.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4 border-t border-[#1a2a40] pt-6">
              <div>
                <div className="text-[11px] font-semibold tracking-widest-custom uppercase text-[#b89c60]">
                  Duração média
                </div>
                <div className="font-serif-display mt-1.5 text-[20px] text-[#ebe6d6]">
                  ~10 meses
                </div>
              </div>
              <div>
                <div className="text-[11px] font-semibold tracking-widest-custom uppercase text-[#b89c60]">
                  Honorários
                </div>
                <div className="font-serif-display mt-1.5 text-[20px] text-[#ebe6d6]">
                  Somente no êxito
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
